<template>
  <div
    class="flex flex-col items-center min-h-screen"
    :style="{ 'background-color': branding.backgroundColor }"
    :class="{ 'blur-md pointer-events-none': blocked }"
  >
    <template v-if="$route.meta.card">
      <c-image
        v-if="!isInIframe"
        :image-id="coverImage"
        class="w-full h-[200px] sm:h-[300px]"
        :mode="isMobile ? 'fill' : 'crop'"
      />
      <div
        class="w-full px-4 pb-10"
        :class="isInIframe ? 'mt-4' : '-mt-14 sm:-mt-[120px]'"
      >
        <div
          class="branding-card relative mx-auto max-w-[440px] bg-surface rounded-3xl px-6 pb-7"
          :class="shouldShowLogo ? 'pt-[116px]' : 'pt-7'"
          :style="cardStyle"
        >
          <div
            v-if="shouldShowLogo"
            class="branding-card-logo absolute -top-24 w-48 h-48 overflow-hidden bg-surface border-[3px] border-surface"
            :class="signupPage?.circleLogo ? 'rounded-full' : 'rounded-[22px]'"
          >
            <c-image
              :image-id="branding.logoImageId"
              class="w-full h-full object-contain"
              mode="fit"
            />
          </div>
          <RouterView />
        </div>
      </div>
    </template>
    <template v-else>
      <c-image
        v-if="!isInIframe"
        :image-id="coverImage"
        class="h-52 w-full"
        :mode="isMobile ? 'fill' : 'crop'"
      />
      <div class="w-5/6">
        <div
          class="absolute floatting rounded-3xl overflow-hidden m-auto border-2 border-white shadow-md shadow-black"
          :class="{ 'rounded-full': signupPage?.circleLogo }"
          v-if="shouldShowLogo"
        >
          <c-image
            :image-id="branding.logoImageId"
            class="h-48 w-48"
            mode="fit"
          />
        </div>
        <div :class="{ 'mt-32': shouldShowLogo, 'mt-10': !shouldShowLogo }">
          <RouterView />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CImage from "../../../core-ui/src/components/CImage.vue";
import { authStore } from "@/stores/auth";
import { mapState } from "pinia";

export default {
  name: "BrandingShell",
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapState(authStore, ["branding", "signupPage", "palette"]),
    // Branding text and accent are picked for the page background; inside
    // the card they're swapped for the versions readable on the surface.
    cardStyle() {
      return {
        "--secondaryColor": this.palette.text,
        "--accentColor": this.palette.accent,
        "--contrastColor": this.palette.onAccent,
        border: this.palette.cardBorder,
      };
    },
    shouldShowLogo() {
      return (
        !this.isInIframe && (!this.signupPage || !this.signupPage.hiddenLogo)
      );
    },
    coverImage() {
      if (this.isMobile) {
        return (
          this.branding.signupMobileCoverImageId || this.branding.coverImageId
        );
      } else {
        return (
          this.branding.signupDesktopCoverImageId ||
          this.branding.signupMobileCoverImageId ||
          this.branding.coverImageId
        );
      }
    },
    isMobile() {
      return window.innerWidth < 640;
    },
    isInIframe() {
      return window.self !== window.top;
    },
  },
  components: {
    CImage,
  },
};
</script>

<style scoped>
.branding-card {
  box-shadow: 0 1px 2px rgba(10, 19, 42, 0.06),
    0 16px 40px rgba(10, 19, 42, 0.1);
}

.branding-card-logo {
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 6px 18px rgba(10, 19, 42, 0.16);
}
</style>
